import {Component, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material';
import {SecondLanguageService} from './shared/services/second-language.service';


// import { TranslateService } from "ng2-translate";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit{
  title = 'app works!';

  constructor(public dialog: MatDialog, private secondLanguageService : SecondLanguageService){
    // translate.addLangs(["en","hi","fr","es"]);
    // translate.setDefaultLang("en");
  };

  ngOnInit():void{
    this.secondLanguageService.setLanguages(["ENG",""]);
  }

  // languages = [
  //   {value: 'en', viewValue: 'English'},
  //   {value: 'hi', viewValue: 'Hindi'},
  //   {value: 'fr', viewValue: 'French'},
  //   {value: 'es', viewValue: 'Spanish'}
  // ];
  //
  //  languageChange(selectedLanguage : string){
  //
  //    this.translate.use(selectedLanguage);
  //  }

}





// WEBPACK FOOTER //
// ./src/app/app.component.ts